import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import ModulePage from "@/pages/ModulePage";
import SyncPage from "@/pages/SyncPage";
import UsersPage from "@/pages/UsersPage";
import WhatsAppPage from "@/pages/WhatsAppPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import LivePage from "@/pages/LivePage";
import UploadPage from "@/pages/UploadPage";
import { MODULE_IDS } from "@/lib/nav";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin text-[#0A3967]" /></div>;
  if (!user) return <Navigate to={`/login${window.location.search}`} replace />;
  return children;
}

function RoleGate({ roles, children }) {
  const { user } = useAuth();
  return roles.includes(user.role) ? children : <Navigate to="/" replace />;
}

function MenuGate({ menu, children }) {
  const { user } = useAuth();
  const ok = menu === "ringkasan" || user.role === "admin" || (user.menus || []).includes(menu);
  return ok ? children : <Navigate to="/" replace />;
}

function ModuleRoute() {
  const { module } = useParams();
  if (!MODULE_IDS.includes(module)) return <Navigate to="/" replace />;
  return <MenuGate menu={module}><ModulePage key={module} module={module} /></MenuGate>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><FilterProvider><AppShell /></FilterProvider></Protected>}>
            <Route index element={<ModulePage key="ringkasan" module="ringkasan" />} />
            <Route path="m/:module" element={<ModuleRoute />} />
            <Route path="live" element={<MenuGate menu="live"><LivePage /></MenuGate>} />
            <Route path="laporan" element={<MenuGate menu="laporan"><ReportsPage /></MenuGate>} />
            <Route path="sync" element={<RoleGate roles={["admin"]}><SyncPage /></RoleGate>} />
            <Route path="upload" element={<RoleGate roles={["admin"]}><UploadPage /></RoleGate>} />
            <Route path="users" element={<RoleGate roles={["admin"]}><UsersPage /></RoleGate>} />
            <Route path="settings" element={<RoleGate roles={["admin"]}><SettingsPage /></RoleGate>} />
            <Route path="whatsapp" element={<RoleGate roles={["admin", "manajemen"]}><WhatsAppPage /></RoleGate>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
